import localhost from "apis/localhost";

export const BASE_API_PATH = "/api/feature-flags";
export const ADMIN_API_PATH = "/api/admin/feature-flags";

/**
 * Fetch the resolved feature flags map for the current deploy.
 */
export const fetchFeatureFlags = async () => {
  const response = await localhost.get(BASE_API_PATH);
  return response?.data ?? {};
};

/**
 * Admin-only: fetch the full set of flags with default/source/audit metadata.
 */
export const fetchFeatureFlagDetails = async () => {
  const response = await localhost.get(ADMIN_API_PATH);
  return response?.data ?? [];
};

/**
 * Admin-only: set or replace an override for the given flag.
 */
export const updateFeatureFlagOverride = async (publicName, enabled) => {
  const response = await localhost.put(`${ADMIN_API_PATH}/${publicName}`, {
    enabled,
  });
  return response?.data;
};

/**
 * Admin-only: remove an override so the flag falls back to property/default.
 */
export const clearFeatureFlagOverride = async (publicName) => {
  const response = await localhost.delete(`${ADMIN_API_PATH}/${publicName}`);
  return response?.data;
};
